import styled from '@benzinga/themetron';

export const LinkDesign = styled.a`
  color: #2ca2d1;
  font-size: 12px;
  margin-top: 8px;
`;
export const Hr = styled.div`
  border-color: #f0f0f0;
  bottom: 17px;
  margin: 0px 10px;
`;
export const Head = styled.th`
  color: #7c7c7c;
`;
